<template>
  <v-app id="app">
    <!-- <Header /> -->
    <SideNavigation />
    <v-content v-bind:class="{ tinted: $store.state.auth.loggedIn }">
      <v-fade-transition mode="out-in">
        <router-view/>
      </v-fade-transition>
    </v-content>
    <BottomNavigation />
    <Snackbar />
<!--    <Footer v-if="!$store.state.auth.loggedIn || $store.state.auth.user.role == 3"/>-->
  </v-app>
</template>

<script>
import router from "@/router";

import Header from "@/components/Header";
import SideNavigation from "@/components/SideNavigation";
import BottomNavigation from "@/components/BottomNavigation";
import Footer from "@/components/Footer";
import Snackbar from "@/components/Snackbar";

export default {
  components: {
    Header,
    SideNavigation,
    BottomNavigation,
    Footer,
    Snackbar
  },
  data() {
    return {};
  },
  created() {
    // global navigation guards
    router.beforeEach((to, from, next) => {
        console.log("auth user: ", this.$store.state.auth.user);
        console.log(" router.beforeEach session user: ", this.$session.get("user"));
      // check if user logged in
      if (this.$store.state.auth.loggedIn) {
        // attempting to reach an authentication route then redirect to dashboard
        if (to.name == "signIn") {
          console.log("already logged in", this.$store.state.auth.user);
          if (this.$store.state.auth.user.role == 3) {
            next({ name: "calendar" });
          } else {
            next({ name: "dashboard" });
          }
        } else {
          // attempting to reach route that user is authorized to access
          console.log("Routing to: ", to);
          if (!to.meta.roles ||to.meta.roles.includes(this.$store.state.auth.user.role)) {
            // proceed to requested page
            next();
          } else {
            next({ name: "notAuthorized" });
          }
        }
        // if user not logged in
      } else {
        // check if this route requires authentication and redirect to fallback
        if (to.matched.some(record => record.meta.requiresAuth)) {
          next({ name: "notAuthenticated" });
        } else {
          // proceed to requested page
          next();
        }
      }
    });

    // check if session exists and retrieve data and redirect to dashboard
    console.log("Session Check");
    if (this.$session.exists()) {
        console.log("Session Check session user: ", this.$session.get("user"));
        console.log("Session found");
      const user = this.$session.get("user");
      console.log("Type: ", typeof user.role, user.role, this.$store.state.auth.user.role);
      if (user.role) {
          console.log("Session User found: ", user, user.role);
        this.$store.dispatch("setUser", user);
        if (this.$store.state.auth.user.role == 3) {
          this.$router.push({ name: "calendar" });
        } else {
          this.$router.push({ name: "dashboard" });
        }
      } else {
        // destroy session since crutial data missing
          console.log("No Session User found");
        this.$session.destroy();
        this.$router.push({ name: "signIn" });
      }
    }
  }
};
</script>


<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.v-content {
  background: url("./assets/background-unsplash.jpg");

  background-size: cover;
  background-position: center center;
}

.tinted {
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0.3)
    ),
    url("./assets/background-unsplash.jpg"); /*white tint*/
}

.btn-submit {
  height: 54px;
  text-transform: capitalize;
}
</style>
